import { FC } from 'react';
import styled from 'styled-components';
import { Box } from '@mui/material';
import { VsTransferEvent } from '@vs-online-only-app/state';
import { OutgoingTransferCard, RootTransferCard } from './OutgoingTransferCard';

const Wrapper = styled.div`
  position: fixed;
  bottom: ${({ theme }) => theme.spacing(2)};
  right: ${({ theme }) => theme.spacing(1)};
  z-index: 10;
`;

const PlaceholderCard = styled(RootTransferCard)<{ index: number }>`
  position: absolute;
  height: ${({ theme }) => theme.spacing(1)};
  top: -${({ theme, index }) => theme.spacing(index)};
  width: calc(400px - ${({ index, theme }) => theme.spacing(2 * (index + 1))});
  z-index: ${({ index }) => -(index + 1)};
`;

type Props = {
  onClick: () => void;
  onCancel: (request: VsTransferEvent) => void;
  onClose: (request: VsTransferEvent) => void;
  transferRequests: VsTransferEvent[];
};

export const CollapsedTransferCards: FC<Props> = ({
  onClick,
  onClose,
  onCancel,
  transferRequests,
}) => {
  const visibleTransferRequest = transferRequests[0];
  return (
    <Wrapper>
      <Box onClick={transferRequests.length ? onClick : undefined}>
        <OutgoingTransferCard
          onClose={() => onClose(visibleTransferRequest)}
          key={visibleTransferRequest.id}
          transferRequest={visibleTransferRequest}
          onCancel={() => onCancel(visibleTransferRequest)}
        />
        {transferRequests.slice(1).map((_, index) => (
          <PlaceholderCard index={index} key={index} />
        ))}
      </Box>
    </Wrapper>
  );
};
